import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestCookiesOrderPut = {
    path: "/cookies/order",
    method: RouteHttpVerb.PUT
};
